import { jsx as _jsx } from "react/jsx-runtime";
import { useLazyQuery } from '@apollo/client';
import { Autocomplete } from '@guildeducationinc/recess';
import { EMPLOYEES } from '@src/graphql/queries/employee';
import { useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
export const EmployeePicker = (props) => {
    const { t } = useLocale();
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [fetchEmployees] = useLazyQuery(EMPLOYEES);
    // Handle initial value and onInit callback
    useEffect(() => {
        if (props.value) {
            // Fetch the employee data for the initial value
            fetchEmployees({
                variables: {
                    spec: {
                        clientId: props.clientId,
                        id: Number(props.value),
                        pagination: { page: 1, pageSize: 1 },
                    },
                },
            }).then(result => {
                if (result.data?.employees?.items?.[0]) {
                    const employee = result.data.employees.items[0];
                    const option = {
                        value: String(employee.id),
                        label: `${employee.firstName} ${employee.lastName} (${employee.uniqueId})`,
                        employee,
                    };
                    setSelectedEmployee(option);
                    props.onInit?.(employee);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value]);
    const handleChange = (e) => {
        if (e.selection === null) {
            props.onChange?.(undefined);
            setSelectedEmployee(null);
            return;
        }
        const employee = e.selection.employee;
        props.onChange?.(employee);
        setSelectedEmployee(e.selection);
    };
    const handleLoad = async (query, callback) => {
        const result = await fetchEmployees({
            variables: {
                spec: {
                    clientId: props.clientId,
                    searchText: query || undefined,
                    pagination: { page: 1, pageSize: 10 },
                },
            },
        });
        if (result.data === undefined) {
            callback([]);
            return;
        }
        const matches = result.data.employees?.items?.map((item) => ({
            value: String(item.id),
            label: `${item.firstName} ${item.lastName} (${item.uniqueId})`,
            employee: item,
        }));
        callback(matches ?? []);
    };
    return (_jsx(Autocomplete, { label: props.label ?? '', placeholder: props.placeholder ?? t('employees.select.employee'), loadOptions: handleLoad, defaultOptions: true, value: selectedEmployee, onChange: handleChange, className: props.className }));
};
